import React from "react";
import { Dialog } from "@headlessui/react";

export interface SearchModalPorps {
  open: boolean;
  closeCallback: any;
  content: any;
}

export default function SearchModal(props: SearchModalPorps) {
  return (
    <Dialog
      open={props.open}
      onClose={() => props.closeCallback()}
      className="relative z-40 w-full"
    >
      <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4 overflow-y-auto pt-16">
        <Dialog.Panel className="mx-auto min-h-full mt-auto md:mt-20 max-w-3xl rounded bg-white">
          {props.content}
        </Dialog.Panel>
      </div>
    </Dialog>
  );
}
